/**
 * 旅行心愿的两个页面，与攻略手账列表里的“想去 / 准备中”（TRV-06，claude-6c2b 分身）。
 * - /guides/wish：当前活动心愿（GET /travel/wish，合同 §23.4，已可接 live）；资料还在查、还没有计划的心愿只能从这里进。
 * - /guides/plan/:planId：某一份计划。live 读 GET /travel/plans/{plan_id}（2026-09-24 23:2x 接上，显式带当前宠物），
 *   再和 GET /travel/wish 的当前心愿按 wish_id 对上（对不上只按计划本身说）；演示仍用演示计划（各带自己的心愿）。
 *   404 plan_not_found（别人家的、不存在的、还没发布过计划的心愿）说“这份计划还没写好，或者已经不在了”；后端没有这条路的路由级 404 不算这一种，走统一错误态。
 * - 页面只认 PlanView（./model）；数据从 ./data 来。标题有宠物名字就用名字，拿不到才写“TA”。数据里没有的块整块不显示，不写“没有写 / 未提供”。
 * - 文字负责好用，手账图负责好看：地名、时间、金额、来源全是页面文字；手账图只占一块留白，没有 / 画着 / 没画成 / 结果未确认 / 没有配图时文字照常；
 *   手账这一页上写的字（标题、一句话、站点、提醒、雨天备选）在图外照常可读（TRV-07：屏幕先显示图外文字），时间用这一页自己的；
 *   没画成、结果未确认且后端给了重画凭据时，live 计划页给“重画这张手账”按钮（./JournalRedraw：能力表 travel.journal_redraw 可用才出现，
 *   主人自己点才发、带幂等键、连点只发一次，付费生图绝不自动触发）；演示、心愿页与能力没开时既没有按钮，也不写重画的说法。
 *   配图被拒的拒绝码、“不画 TA”的原因码不上页面（X-09：玩家端不显示技术代码，也不做折叠区）。
 * - 用了驾校借车券（fare_waived）：写“用了驾校借车券，这趟不用租车费”，标价划掉显示，不把标价说成付过的钱（合同 §30）。
 * - 路费由平台补助（fare_sponsor，先看它）：写“这趟路费由星球活动补助”“TA 没有花钱”，标价照样划掉；补助来源的码、活动号不显示（DS5）。
 * - 外链一律新窗口、rel="noopener noreferrer"，只收 http(s)（./model 的 safeHref）：资料来源，和后端给的地图链接 nav_url（不拿 lat/lng 自己拼）。
 * - 联网检索（能力表 travel.research）不是 available 时（没开通、还没读到；演示按能查说，给人看产品本来的样子）：不许诺会去查、会补上、还在确认——
 *   状态标签、“还差什么”、出发前那句、还没有计划时的三句空话、资料旁的小标签都换成眼下的实情（说法在 ./model，读法在 ./research，同 ./JournalRedraw）。
 *   页面本来就没有“重新研究”按钮，也不加（能力说明写着不必给）。
 * - 心愿已经有计划（心愿页给“看这份计划”）：心愿页只说心愿本身（为什么想去、还差什么、攒钱目标），路线、地点、顺路建议、资料来源都在计划页；
 *   心愿页不再照“还没有计划”说“地点暂时核不了 / 资料暂时查不到 / TA 正在准备”，和计划页说反话（2026-09-26 巡检 R14-A02 / A04）。
 *   “有计划”＝plan_id 和 plan_revision 都有（./model 的 publishedPlanOf）：后端在心愿一形成就给了 plan_id，资料还在查、资料待补的心愿
 *   只有 plan_id，这时照“还没有计划”说，不说“计划已经写好了”、不给链接（点进去是“这份计划还没写好”，DS5）；
 *   攻略手账列表里这种心愿的卡片右下角写“看心愿”，有写好计划的卡片才写“看计划”。
 * - 回来了的当前心愿：攻略页卡片那句、心愿页顶上那句“这一趟的结果”照计划页的口径说（读那份计划的回忆手账，同一个查询键、共用缓存）；
 *   读不到就不下结论（“这一趟去了哪些地方，在计划里看”），不说“到访记录还在整理”（计划页可能早就盖好“到过”了，巡检 R15-P7-07 / 08，DS5）。
 * - 手账图在画时计划每 10 秒只读重取一次，画好就停（./data 的 useLivePlan）；在画的留白有一道很淡的光慢慢扫过，减少动态效果时不动。
 * - 本地心愿（destination_key 以 local: 开头，DS5）：跳过联网研究的最简计划。手账按设计不画图（image_refused 是 local_trip_no_image）时只有文字，
 *   不留图框、不说“只有文字”，时间写在手账下面；本地去处的地点卡不写核实那一行；没有的块（来源、提醒、顺路建议……）照常整块不出。
 * - 点按区不小于 44px 高（“看这份计划”是按钮；资料来源、地图链接只加大点按区，不改样子；2026-09-26 巡检）。
 * - 惦记（UI-LONGING-WIRE-01，10-13；合同 TRV-00 §38.3，用户 09-27「需要惦记」）：TA 惦记着一处此刻去不了的远方时，
 *   心愿页没有心愿就画惦记（不再说“没有想去的地方”），有心愿就在心愿下面补一节“还惦记着”；攻略手账的“想去 / 准备中”单列一张惦记卡。
 *   只说事实（地方、TA 自己说的理由、从哪天起、这里现在去不了），不许诺；版式沿用心愿那一套，不加新图。
 *   惦记还在读时，心愿页没有心愿就先等（不先说“没有”再改口）；读不到（出错、没接）照原来的样子说，不因此把心愿页弄坏。
 */
import { useId, type ReactNode } from "react";
import { Link, useParams } from "react-router";
import { env } from "@/shared/config/env";
import type { TravelPlan, TravelWish } from "@/shared/contracts";
import { useOptionalCurrentHousehold } from "@/shared/session/householdContext";
import { Chip, DataOriginBadge, EmptyState, ErrorState, Icon, LoadingState, Page, PlanetEventLine, TopBar } from "@/shared/ui";
import { isPetRequired, isPlanNotFound, useCurrentLonging, useCurrentWish, useDemoPlans, useLivePlan, type Read } from "./data";
import { viewOfLonging, type LongingView } from "./longing";
import { hasWrittenPlan, outcomePlanOf, SAFETY_STICKERS, viewOfPlan, viewOfPlanOnly, viewOfWish, type JournalTextView, type LineView, type NoticeTipView, type PlaceStamp, type PlaceView, type PlanView, type ViewOptions } from "./model";
import { JournalRedraw } from "./JournalRedraw";
import { useResearchAvailable } from "./research";
import "./plan.css";

/** 当前宠物的名字；拿不到（演示世界的家庭上下文没有当前宠物）就是 null，页面写“TA”。 */
export function usePetName(): string | null {
  return useOptionalCurrentHousehold()?.pet?.name ?? null;
}

function useViewOptions(): ViewOptions {
  return { petName: usePetName(), isDemo: env.dataMode === "fixture", researchAvailable: useResearchAvailable() };
}

/**
 * 当前宠物的惦记（UI-LONGING-WIRE-01）：loading＝还在读；longing＝TA 惦记着一处；none＝确实没有；
 * unknown＝读不到（出错、能力没接、还没确认身份）——这时页面照原来的样子说，不因为惦记读不到把心愿页、攻略手账弄坏。
 */
export type LongingState = { state: "loading" } | { state: "none" } | { state: "unknown" } | { state: "longing"; view: LongingView };
export function useLongingState(): LongingState {
  const read = useCurrentLonging();
  const petName = usePetName();
  if (read.state === "loading") return { state: "loading" };
  if (read.state !== "ready") return { state: "unknown" };
  const view = viewOfLonging(read.data, { petName });
  return view.kind === "longing" ? { state: "longing", view } : { state: "none" };
}

/** 惦记那一句事实：这里现在去不了，TA 只是惦记着（惦记期间不查资料、不出门，./longing 的口径）。不许诺，守卫钉着。 */
export const LONGING_FACT = "这里现在去不了：TA 只是惦记着，不为它查资料，也不出门。";

/**
 * 回来了的当前心愿：“这一趟的结果”只有那份计划的回忆手账说得准（./model 的 outcomePlanOf、viewOfWish）。
 * live 读那份计划——和计划页、回忆页同一个查询键（./data 的 useLivePlan / planQueryKey），共用缓存；只读一次，不跟着手账图轮询。
 * 演示用演示计划里同一份。别的阶段不读（ready＋data null）。还在读就是 loading（先不说，免得先说一句再改口）；读不到就是 data null，那句不下结论。
 */
function useOutcomePlan(wish: TravelWish | null): Read<TravelPlan | null> {
  const fixture = env.dataMode === "fixture";
  const planId = wish ? outcomePlanOf(wish) : null;
  const live = useLivePlan(!fixture && planId ? planId : undefined, { poll: false });
  const demo = useDemoPlans();
  if (!planId) return { state: "ready", data: null };
  if (fixture) {
    if (demo.state === "loading") return { state: "loading" };
    return { state: "ready", data: demo.state === "ready" ? (demo.data.find((bundle) => bundle.plan.plan_id === planId)?.plan ?? null) : null };
  }
  if (live.state === "loading") return { state: "loading" };
  return { state: "ready", data: live.state === "ready" ? live.data : null };
}

/**
 * 攻略手账列表的“想去 / 准备中”。null＝没有可显示的（还在加载、取不到、live 下没有活动心愿），列表不显示这一块。
 * live 现在只有当前活动心愿（GET /travel/wish）；演示另有几份计划。
 * 当前心愿回来了：等那份计划读完再出这一块，卡片那句照计划页的口径说（DS5，巡检 R15-P7-07 / 08）。
 */
export function useShelfViews(): PlanView[] | null {
  const wish = useCurrentWish();
  const plans = useDemoPlans();
  const options = useViewOptions();
  const current = wish.state === "ready" && wish.data ? wish.data : null;
  const outcome = useOutcomePlan(current);
  if (wish.state === "loading" || plans.state === "loading" || outcome.state === "loading") return null;
  // 当前心愿若已有计划，列表里只放当前心愿那一张（进 /guides/wish），不重复放它的计划。
  const others = plans.state === "ready" ? plans.data.filter((bundle) => bundle.wish.wish_id !== current?.wish_id).map((bundle) => viewOfPlan(bundle, options)) : [];
  const views = [...(current ? [viewOfWish(current, options, outcome.state === "ready" ? outcome.data : null)] : []), ...others];
  return views.length ? views : null;
}

function PendingTag({ children }: { children: ReactNode }) {
  return <span className="ps-plan-tag ps-plan-tag--pending">{children}</span>;
}

/** 一行提醒；依据的资料有问题时旁边带小标签（说法随联网检索能不能用而变，见 PlanView.notes）。 */
function Line({ line, pendingLabel }: { line: LineView; pendingLabel: string }) {
  return (
    <>
      <span>{line.text}</span>
      {line.pending ? <PendingTag>{pendingLabel}</PendingTag> : null}
    </>
  );
}

/**
 * “提醒”列表里这一行贴不贴纸：后端标了认得的贴纸、依据的公告原话拿得出来（PlanView.noticeTips；手账页是 JournalTextView.noticeTips）、贴纸图也有了的才贴。
 * 便签样式等参考图，眼下只把贴纸放在这一行圆点的位置，字和别的提醒一样。
 */
function stickerAt(noticeTips: NoticeTipView[], index: number): { name: string; image: string } | null {
  const tip = noticeTips.find((t) => t.index === index);
  const art = tip ? SAFETY_STICKERS[tip.sticker] : null;
  return art?.image ? { name: art.name, image: art.image } : null;
}

function Stamp({ stamp }: { stamp: PlaceStamp | null }) {
  return stamp ? <span className={`ps-plan-stamp ps-plan-stamp--${stamp.kind}`}>{stamp.label}</span> : null;
}

function PlaceItem({ place, pendingLabel }: { place: PlaceView; pendingLabel: string }) {
  return (
    <div className={`ps-plan-place ps-plan-place--${place.role}`} data-place-id={place.id}>
      <div className="ps-plan-place__head">
        <strong>{place.name}</strong>
        {place.role === "suggested" ? <span className="ps-plan-tag">顺路建议</span> : null}
        <Stamp stamp={place.stamp} />
      </div>
      {place.why ? <p>{place.why}</p> : null}
      {place.tip || place.pending ? (
        <p className="ps-plan-place__tip">
          {place.tip ? <span>{place.tip}</span> : null}
          {place.pending ? <PendingTag>{pendingLabel}</PendingTag> : null}
        </p>
      ) : null}
      {/* 本地去处不需要核实：没有“地点已核对 / 核不了”这一行；也没有地图链接时整行不出。 */}
      {place.verifyText || place.mapUrl ? (
        <div className="ps-plan-place__foot">
          {place.verifyText ? <small>{place.verifyText}</small> : null}
          {/* 后端给的 nav_url（高德、WGS-84、只有核实过的地点才有），新窗口打开；没有就不给，前端不拿坐标自己拼。 */}
          {place.mapUrl ? (
            <a href={place.mapUrl} target="_blank" rel="noopener noreferrer">
              在地图上看 ↗
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

/** 手账这一页上写的字（图外可读）：标题、一句话、站点（回忆页带章）、提醒、雨天备选。 */
function JournalPage({ text, pendingLabel }: { text: JournalTextView; pendingLabel: string }) {
  const id = useId();
  return (
    <div className="ps-plan-journal__page" role="group" aria-labelledby={id}>
      <p className="ps-plan-journal__kicker" id={id}>
        手账上写着
      </p>
      {text.title ? <h3>{text.title}</h3> : null}
      {text.summary ? <p>{text.summary}</p> : null}
      {text.stations.length ? (
        <ol className="ps-plan-journal__stations">
          {text.stations.map((station) => (
            <li key={station.key}>
              <span>{station.name}</span>
              {station.role === "suggested" ? <span className="ps-plan-tag">顺路建议</span> : null}
              <Stamp stamp={station.stamp} />
            </li>
          ))}
        </ol>
      ) : null}
      {text.tips.length ? (
        <ul className="ps-plan-lines">
          {text.tips.map((line, index) => {
            const sticker = stickerAt(text.noticeTips, index);
            return (
              <li key={`${index}-${line.text}`} className={sticker ? "ps-plan-line--sticker" : undefined}>
                {sticker ? <img className="ps-plan-sticker" src={sticker.image} alt={sticker.name} width={24} height={24} /> : null}
                <Line line={line} pendingLabel={pendingLabel} />
              </li>
            );
          })}
        </ul>
      ) : null}
      {text.rain ? <p>雨天备选：{text.rain}</p> : null}
    </div>
  );
}

/** 重画要打到哪一份计划、哪只宠物：只有 live 的计划页给（演示、心愿页不给，就不会有重画按钮）。 */
export interface RedrawTarget {
  planId: string;
  petId: string | null;
}

/** 计划正文（两个页面与测试共用）：先文字、后手账图，来源放最后。 */
export function PlanContent({ view, redraw, extra }: { view: PlanView; redraw?: RedrawTarget | null; extra?: ReactNode }) {
  const id = useId();
  const h = (name: string) => `${id}-${name}`;
  return (
    <article className="ps-plan" data-stage={view.stage}>
      <header className="ps-plan-hero">
        <div className="ps-plan-hero__tags">
          <Chip tone={view.status.tone}>{view.status.label}</Chip>
          {view.isDemo ? <DataOriginBadge origin="fixture" label="演示计划" /> : null}
        </div>
        <p className="ps-plan-hero__dest">
          <Icon name="pin" size={18} />
          <span>{view.destination}</span>
        </p>
        {view.planTitle ? <p className="ps-plan-hero__plan">{view.planTitle}</p> : null}
        <p className="ps-plan-hero__summary">{view.summary}</p>
      </header>

      {/* 数据里没有的整块不显示，不写“没有写 / 未提供”（只按计划本身说时，TA 的理由在心愿里，这里不编）。 */}
      {view.reason ? (
        <section className="ps-plan-section" aria-labelledby={h("why")}>
          <h2 id={h("why")}>我为什么想去</h2>
          <blockquote className="ps-plan-quote">
            <p>“{view.reason}”</p>
            <footer>TA 自己说的</footer>
          </blockquote>
        </section>
      ) : null}

      {view.stage === "wish" || view.stage === "ready" ? (
        <section className="ps-plan-section" aria-labelledby={h("waiting")}>
          <h2 id={h("waiting")}>还差什么</h2>
          {view.waiting.length ? (
            <ul className="ps-plan-waiting">
              {view.waiting.map((item) => (
                <li key={item.key}>
                  <span className="ps-plan-waiting__icon" aria-hidden="true">
                    <Icon name={item.icon} size={16} />
                  </span>
                  <span>
                    <strong>{item.text}</strong>
                    {item.detail ? <small>{item.detail}</small> : null}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="ps-plan-muted">{view.stage === "ready" ? "都准备好了。出不出发、哪天走，由 TA 自己决定。" : "还在准备。"}</p>
          )}
        </section>
      ) : null}

      {view.preconditions.length ? (
        <section className="ps-plan-section" aria-labelledby={h("pre")}>
          <h2 id={h("pre")}>出发前会再确认</h2>
          <p className="ps-plan-note">{view.notes.preconditions}</p>
          <ul className="ps-plan-lines ps-plan-pre">
            {view.preconditions.map((item) => (
              <li key={item.key}>
                <span>
                  {item.topic}
                  {item.detail ? `：${item.detail}` : ""}
                </span>
                {item.pendingText ? <PendingTag>{item.pendingText}</PendingTag> : item.until ? <small>{item.until}</small> : null}
              </li>
            ))}
          </ul>
        </section>
      ) : null}

      {view.arrangement || view.validity || view.planLink || !view.planWritten ? (
        <section className="ps-plan-section" aria-labelledby={h("steps")}>
          <h2 id={h("steps")}>行动安排</h2>
          {view.validity ? <p className="ps-plan-note">按这一天的资料安排：{view.validity}</p> : null}
          {view.arrangement ? (
            <p className="ps-plan-arrangement">{view.arrangement}</p>
          ) : view.planLink ? (
            // 心愿已经有计划：这一页不照“还没有计划”说（R14-A02 / A04）；去计划页是一个按钮（点按区 44px）。
            // 这句不列举计划里有什么（原来写“路线、地点和资料来源”，对没有资料来源、没有路线的计划是多说，DS5 本地心愿调查后主窗口定）。
            <div className="ps-plan-elsewhere">
              <p className="ps-plan-muted">计划已经写好了，都在这份计划里。</p>
              <Link className="ps-btn ps-btn--secondary" to={view.planLink}>
                看这份计划
              </Link>
            </div>
          ) : view.planWritten ? null : (
            <p className="ps-plan-muted">{view.notes.noSteps}</p>
          )}
        </section>
      ) : null}

      {/* 心愿已经有计划时，地点、顺路建议、资料来源都在计划页，这一页不显示（不说“地点暂时核不了 / 查不到 / 正在准备”）。 */}
      {view.planLink ? null : (
        <section className="ps-plan-section" aria-labelledby={h("main")}>
          <h2 id={h("main")}>主目的地</h2>
          <PlaceItem place={view.main} pendingLabel={view.notes.placePending} />
        </section>
      )}

      {!view.planLink && (view.suggestions.length || !view.planWritten) ? (
        <section className="ps-plan-section" aria-labelledby={h("along")}>
          <h2 id={h("along")}>顺路建议</h2>
          <p className="ps-plan-note">顺路看看的地方，只是建议，不算到访。</p>
          {view.suggestions.length ? (
            <ul className="ps-plan-places">
              {view.suggestions.map((place) => (
                <li key={place.id}>
                  <PlaceItem place={place} pendingLabel={view.notes.placePending} />
                </li>
              ))}
            </ul>
          ) : (
            <p className="ps-plan-muted">{view.notes.noAlong}</p>
          )}
        </section>
      ) : null}

      {view.reminders.length ? (
        <section className="ps-plan-section" aria-labelledby={h("tips")}>
          <h2 id={h("tips")}>提醒</h2>
          <ul className="ps-plan-lines">
            {view.reminders.map((line, index) => {
              const sticker = stickerAt(view.noticeTips, index);
              return (
                <li key={`${index}-${line.text}`} className={sticker ? "ps-plan-line--sticker" : undefined}>
                  {sticker ? <img className="ps-plan-sticker" src={sticker.image} alt={sticker.name} width={24} height={24} /> : null}
                  <Line line={line} pendingLabel={view.notes.linePending} />
                </li>
              );
            })}
          </ul>
        </section>
      ) : null}

      {view.rainPlan ? (
        <section className="ps-plan-section" aria-labelledby={h("rain")}>
          <h2 id={h("rain")}>雨天备选</h2>
          <p className="ps-plan-rain">{view.rainPlan}</p>
        </section>
      ) : null}

      {view.coins || view.realCosts.length ? (
        <section className="ps-plan-section" aria-labelledby={h("money")}>
          <h2 id={h("money")}>花费</h2>
          <div className="ps-plan-money">
            {view.coins ? (
              <div className="ps-plan-money__item ps-plan-money__item--coins" data-money="coins">
                <span className="ps-plan-money__kind">
                  <Icon name="coin" size={14} />
                  游戏里的星币
                </span>
                <strong>{view.coins.text}</strong>
                {/* 用了驾校借车券或平台补助：标价划掉显示，它不是付过的钱。 */}
                {view.coins.listPrice ? (
                  <small className="ps-plan-money__list-price">
                    标价 <s>{view.coins.listPrice}</s>
                  </small>
                ) : null}
                {view.coins.detail ? <small>{view.coins.detail}</small> : null}
              </div>
            ) : null}
            {view.realCosts.length ? (
              <div className="ps-plan-money__item ps-plan-money__item--real" data-money="real">
                <span className="ps-plan-money__kind">
                  <Icon name="info" size={14} />
                  现实参考 · 给你看
                </span>
                <ul className="ps-plan-money__list">
                  {view.realCosts.map((cost) => (
                    <li key={cost.key} data-cost={cost.key}>
                      <strong>{cost.text}</strong>
                      <small>{cost.meta}</small>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          {view.realCosts.length ? <p className="ps-plan-note">现实参考只给你看，不会换算成星币；TA 在星球上只花星币。</p> : null}
        </section>
      ) : null}

      {/* 还没有手账（这一版没有 journals，或心愿还没有计划）：整块不显示。 */}
      {view.journal.text ? (
        <section className="ps-plan-section" aria-labelledby={h("journal")}>
          <h2 id={h("journal")}>{view.journal.heading}</h2>
          {/* 这一趟车费由星球活动补助时：“星球活动：xxx”（看板 #11；没有活动名就不画），各种画面状态（含只有文字）都在 */}
          <PlanetEventLine event={view.journal.planetEvent} />
          {/* 按设计不画图（text_only）：不留图框，也不说“只有文字”；下面手账上的字照常，这一页的时间写在最后。 */}
          {view.journal.state === "text_only" ? null : (
            <figure className={`ps-plan-journal ps-plan-journal--${view.journal.state}`} data-journal={view.journal.state}>
              {view.journal.imageUrl ? (
                <img src={view.journal.imageUrl} alt={`${view.journal.heading}的画面`} loading="lazy" />
              ) : (
                <div className="ps-plan-journal__blank" aria-hidden="true">
                  <Icon name="bookmark" size={26} />
                </div>
              )}
              <figcaption>
                <strong>{view.journal.caption}</strong>
                {view.journal.staleNote ? <span className="ps-plan-journal__stale">{view.journal.staleNote}</span> : null}
                {view.journal.identity ? <span className="ps-plan-journal__identity">{view.journal.identity}</span> : null}
                {view.journal.state === "ready" ? null : <span>文字都在这一页，照常可以看。</span>}
                {view.journal.time ? <small className="ps-plan-journal__time">{view.journal.time}</small> : null}
              </figcaption>
            </figure>
          )}
          {view.journal.redraw && redraw && view.planRevision != null ? (
            <JournalRedraw
              key={view.journal.redraw.journalId}
              planId={redraw.planId}
              petId={redraw.petId}
              expectedRevision={view.planRevision}
              journalId={view.journal.redraw.journalId}
              ticket={view.journal.redraw.ticket}
              unknown={view.journal.state === "unknown"}
            />
          ) : null}
          <JournalPage text={view.journal.text} pendingLabel={view.notes.linePending} />
          {view.journal.state === "text_only" && view.journal.time ? <p className="ps-plan-muted ps-plan-journal__written">{view.journal.time}</p> : null}
        </section>
      ) : null}

      {!view.planLink && (view.sources.length || !view.planWritten) ? (
        <section className="ps-plan-section" aria-labelledby={h("sources")}>
          <h2 id={h("sources")}>资料来源</h2>
          {view.sources.length ? (
            <ul className="ps-plan-sources">
              {view.sources.map((source) => (
                <li key={source.id} data-pending={source.pendingText ? "true" : "false"}>
                  <div className="ps-plan-sources__head">
                    <span>{source.topic}</span>
                    {source.pendingText ? <PendingTag>{source.pendingText}</PendingTag> : <span className="ps-plan-tag ps-plan-tag--ok">已核对</span>}
                  </div>
                  {source.detail ? <p className="ps-plan-sources__value">{source.detail}</p> : null}
                  {source.refs.map((ref) => (
                    <div key={ref.key} className="ps-plan-sources__ref">
                      <p>
                        来源：
                        {ref.href ? (
                          <a href={ref.href} target="_blank" rel="noopener noreferrer">
                            {ref.publisher}
                          </a>
                        ) : (
                          ref.publisher
                        )}
                      </p>
                      {ref.times.map((time) => (
                        <small key={time}>{time}</small>
                      ))}
                    </div>
                  ))}
                  {source.times.map((time) => (
                    <small key={time}>{time}</small>
                  ))}
                </li>
              ))}
            </ul>
          ) : (
            <p className="ps-plan-muted">{view.notes.noSources}</p>
          )}
        </section>
      ) : null}
      {extra}
    </article>
  );
}

/**
 * 读的几种状态：读不了（whenUnavailable：两个页面都是“需要先选一只宠物”）、加载中、
 * 出错（能重试的给重试；whenError 可以把某些错误换成专门的说法）、读到了。
 */
function ReadGate<T>({
  read,
  found,
  empty,
  whenUnavailable,
  whenError,
  onRetry,
  children,
}: {
  read: Read<T>;
  found: boolean;
  empty: ReactNode;
  whenUnavailable: ReactNode;
  whenError?: (error: unknown) => ReactNode | null;
  onRetry?: () => void;
  children: ReactNode;
}) {
  if (read.state === "unavailable") return <>{whenUnavailable}</>;
  if (read.state === "loading") return <LoadingState lines={3} label="正在翻开 TA 的计划…" />;
  if (read.state === "error") return <>{whenError?.(read.error) ?? <ErrorState error={read.error} onRetry={onRetry ?? read.retry} />}</>;
  return <>{found ? children : empty}</>;
}

/**
 * 这份计划还没写好，或者已经不在了：后端答 404 plan_not_found——别人家的、不存在的、还没发布过计划的心愿，三种不可区分（合同 §7）；
 * 演示里没有这一份也这样说。错误码、原因码、request_id 不上页面（用户 10-09 定稿 X-09／U-26：玩家端不显示技术代码、请求编号、错误码，也不做“展开看详情”的折叠区，要查只在运营后台查），玩家只看人话；
 * error 照旧收着（调用方不用改），只是不再用它拼字。
 * 后端没有这条路（路由级 404，不带 reason）不走这里：照常是统一错误态（“这里还没有路”）。
 * 说了“回到手账列表看看”，就在这句下面给去手账列表（/guides，这一页的上级）的按钮。
 */
export function PlanMissing(_props: { error?: unknown }) {
  return (
    <EmptyState
      icon="bookmark"
      title="这份计划还没写好，或者已经不在了"
      action={
        <Link className="ps-btn ps-btn--primary" to="/guides">
          回到手账列表
        </Link>
      }
    >
      回到手账列表看看。
    </EmptyState>
  );
}

/**
 * 定不了是哪只宠物：后端答 409 pet_required（§29.5），或者 live 下这一页拿不到当前宠物（不拿 null 让后端去推）。
 * 说要先选一只，不白屏、不一直转；原因码不上页面（X-09）。error 照旧收着，调用方不用改。
 */
export function PetRequired(_props: { error?: unknown }) {
  return (
    <EmptyState icon="user" title="需要先选一只宠物">
      先选好要看的是哪一只，再回来看 TA 想去哪里。
    </EmptyState>
  );
}

/**
 * 心愿页只有惦记、没有心愿时画的惦记（UI-LONGING-WIRE-01）：和心愿同一套版式；地方、TA 自己说的理由、从哪天起、这里现在去不了。
 */
function LongingContent({ longing }: { longing: LongingView }) {
  const id = useId();
  return (
    <article className="ps-plan" data-stage="longing" data-longing-id={longing.longingId}>
      <header className="ps-plan-hero">
        <div className="ps-plan-hero__tags">
          <Chip tone="neutral">惦记着</Chip>
          {env.dataMode === "fixture" ? <DataOriginBadge origin="fixture" label="演示" /> : null}
        </div>
        <p className="ps-plan-hero__dest">
          <Icon name="pin" size={18} />
          <span>{longing.name}</span>
        </p>
        <p className="ps-plan-hero__summary">{LONGING_FACT}</p>
      </header>
      {longing.reason ? (
        <section className="ps-plan-section" aria-labelledby={`${id}-why`}>
          <h2 id={`${id}-why`}>我为什么惦记</h2>
          <blockquote className="ps-plan-quote">
            <p>“{longing.reason}”</p>
            <footer>TA 自己说的</footer>
          </blockquote>
        </section>
      ) : null}
      {longing.since ? <p className="ps-plan-muted">从 {longing.since} 起惦记着。</p> : null}
    </article>
  );
}

/** 心愿页有心愿、TA 另外还惦记着一处时，心愿下面补的一节（UI-LONGING-WIRE-01）。 */
function LongingNote({ longing }: { longing: LongingView }) {
  const id = useId();
  return (
    <section className="ps-plan-section" aria-labelledby={`${id}-longing`} data-longing-id={longing.longingId}>
      <h2 id={`${id}-longing`}>还惦记着</h2>
      <p className="ps-plan-muted">
        {longing.line}{longing.since ? `（${longing.since} 起）` : ""}。{LONGING_FACT}
      </p>
      {longing.reason ? (
        <blockquote className="ps-plan-quote">
          <p>“{longing.reason}”</p>
          <footer>TA 自己说的</footer>
        </blockquote>
      ) : null}
    </section>
  );
}

/**
 * /guides/wish：当前活动心愿（GET /travel/wish）。
 * 回来了时顶上那句“这一趟的结果”照计划页的口径说（读那份计划，同攻略页卡片，见 useOutcomePlan）；那份计划还在读时整页先等它。
 * 惦记（UI-LONGING-WIRE-01）：没有心愿、TA 惦记着一处时画惦记；有心愿时惦记补在心愿下面。没有心愿而惦记还在读时整页先等它。
 */
export function WishPage() {
  const wish = useCurrentWish();
  const options = useViewOptions();
  const longing = useLongingState();
  const outcome = useOutcomePlan(wish.state === "ready" ? wish.data : null);
  const view = wish.state === "ready" && wish.data && outcome.state === "ready" ? viewOfWish(wish.data, options, outcome.data) : null;
  const settled = wish.state === "ready" && outcome.state !== "loading";
  const onlyLonging = settled && !view && longing.state === "longing" ? longing.view : null;
  const read: Read<unknown> = (wish.state === "ready" && outcome.state === "loading") || (settled && !view && longing.state === "loading") ? { state: "loading" } : wish;
  return (
    <Page className="ps-plan-page">
      <TopBar title={<span className="ps-plan-title">{view?.title ?? onlyLonging?.line ?? "旅行心愿"}</span>} sourceBack={{ fallback: "/guides", levelParent: "/guides" }} />
      <ReadGate
        read={read}
        found={Boolean(view || onlyLonging)}
        empty={
          <EmptyState icon="bookmark" title={`${options.petName ?? "TA"} 现在没有想去的地方`}
            action={<Link className="ps-plan-empty-nav" to="/journey"><Icon name="compass" size={18} />看看TA的旅途<Icon name="chevron" size={16} /></Link>}
          >
            有了想去的地方，会在这里写下为什么想去、还差什么。
          </EmptyState>
        }
        whenUnavailable={<PetRequired />}
        whenError={(error) => (isPetRequired(error) ? <PetRequired error={error} /> : null)}
      >
        {view ? <PlanContent view={view} extra={longing.state === "longing" ? <LongingNote longing={longing.view} /> : null} /> : onlyLonging ? <LongingContent longing={onlyLonging} /> : null}
      </ReadGate>
    </Page>
  );
}

/**
 * /guides/plan/:planId：某一份计划。
 * - live：GET /travel/plans/{plan_id}（带当前宠物）＋ GET /travel/wish。两边 wish_id 对得上才放在一起（viewOfPlan）；
 *   对不上、或者心愿读不到，都只按计划本身说（viewOfPlanOnly）——计划本身不因为心愿读不到而不显示；
 *   心愿还在读时先等它，免得先按计划本身说、一会儿又换成心愿的状态（页面跳一下）。
 * - 演示：演示计划各带自己的心愿（PlanBundle）；演示里没有这一份，就说计划还没写好或者已经不在了。
 */
export function PlanPage() {
  const { planId } = useParams();
  const fixture = env.dataMode === "fixture";
  const plans = useDemoPlans();
  const livePlan = useLivePlan(planId);
  const wish = useCurrentWish();
  const options = useViewOptions();
  const petId = useOptionalCurrentHousehold()?.pet?.pet_id ?? null;
  let redraw: RedrawTarget | null = null;
  let read: Read<unknown>;
  let view: PlanView | null = null;
  if (fixture) {
    read = plans;
    const bundle = plans.state === "ready" ? (plans.data.find((candidate) => candidate.plan.plan_id === planId) ?? null) : null;
    view = bundle ? viewOfPlan(bundle, options) : null;
  } else if (livePlan.state === "ready" && wish.state === "loading") {
    read = { state: "loading" };
  } else {
    read = livePlan;
    if (livePlan.state === "ready") {
      const current = wish.state === "ready" && wish.data && wish.data.wish_id === livePlan.data.wish_id ? wish.data : null;
      view = current ? viewOfPlan({ wish: current, plan: livePlan.data }, options) : viewOfPlanOnly(livePlan.data, options);
      redraw = { planId: livePlan.data.plan_id, petId };
    }
  }
  return (
    <Page className="ps-plan-page">
      <TopBar title={<span className="ps-plan-title">{view?.title ?? "旅行计划"}</span>} back="/guides" />
      <ReadGate
        read={read}
        found={Boolean(view)}
        empty={<PlanMissing />}
        whenUnavailable={<PetRequired />}
        whenError={(error) => (isPlanNotFound(error) ? <PlanMissing error={error} /> : isPetRequired(error) ? <PetRequired error={error} /> : null)}
      >
        {view ? <PlanContent view={view} redraw={redraw} /> : null}
      </ReadGate>
    </Page>
  );
}

/**
 * 攻略手账列表里的一张卡。右下角：背后有写好的计划（./model 的 hasWrittenPlan，心愿按 publishedPlanOf 的口径）写“看计划”；
 * 计划还没写好的心愿（资料还在查、资料待补）写“看心愿”——点进去是心愿页，没有计划可看（DS5 后续，主窗口定）。
 */
function PlanCard({ view }: { view: PlanView }) {
  return (
    <Link to={view.href} className="ps-plan-card" data-plan-id={view.key}>
      <span className="ps-plan-card__top">
        <Chip tone={view.status.tone}>{view.status.label}</Chip>
        {view.isDemo ? <DataOriginBadge origin="fixture" label="演示" /> : null}
      </span>
      <strong className="ps-plan-card__title">{view.title}</strong>
      <span className="ps-plan-card__line">{view.cardLine}</span>
      <span className="ps-plan-card__open">
        {hasWrittenPlan(view) ? "看计划" : "看心愿"} <Icon name="chevron" size={15} />
      </span>
    </Link>
  );
}

/**
 * 攻略手账“想去 / 准备中”里的惦记卡（UI-LONGING-WIRE-01）：点进心愿页（没有心愿时那里画惦记，有心愿时惦记在心愿下面）。
 */
function LongingCard({ longing }: { longing: LongingView }) {
  return (
    <Link to="/guides/wish" className="ps-plan-card" data-longing-id={longing.longingId}>
      <span className="ps-plan-card__top">
        <Chip tone="neutral">惦记着</Chip>
        {env.dataMode === "fixture" ? <DataOriginBadge origin="fixture" label="演示" /> : null}
      </span>
      <strong className="ps-plan-card__title">{longing.line}</strong>
      <span className="ps-plan-card__line">{longing.since ? `${longing.since} 起惦记着；这里现在去不了。` : "这里现在去不了。"}</span>
      <span className="ps-plan-card__open">
        看惦记 <Icon name="chevron" size={15} />
      </span>
    </Link>
  );
}

/**
 * 攻略手账列表里的“想去 / 准备中”。只列想去和可以出发的；出发之后、放下的放在下面“后来怎样”，不和“想去”混在一起
 * （主窗口定：先留着，真实情况等接口定）。演示时把几种状态放在一起，所以明写“真实情况下 TA 同一时间只有一个想去的地方”（“惦记”留给惦记着的远方，2026-09-27）。
 */
export function PlanShelf({ views, longing = null }: { views: PlanView[]; longing?: LongingView | null }) {
  const id = useId();
  const wishing = views.filter((view) => view.stage === "wish" || view.stage === "ready");
  const after = views.filter((view) => view.stage !== "wish" && view.stage !== "ready");
  const demo = views.some((view) => view.isDemo);
  return (
    <section className="ps-plan-shelf" aria-labelledby={`${id}-wishing`} data-shelf="wishing">
      <div className="ps-plan-shelf__head">
        <h2 id={`${id}-wishing`}>想去 / 准备中</h2>
        {demo ? <DataOriginBadge origin="fixture" label="演示" /> : null}
      </div>
      {demo ? <p className="ps-plan-shelf__note">演示：几种状态放在一起给你看；真实情况下，TA 同一时间只有一个想去的地方。</p> : null}
      {wishing.length ? (
        <ul className="ps-plan-cards">
          {wishing.map((view) => (
            <li key={view.key}>
              <PlanCard view={view} />
            </li>
          ))}
        </ul>
      ) : (
        // 有惦记时不说“没有想去的地方”（TA 惦记着一处，说没有就不实）：只说眼下没有准备去的
        <p className="ps-plan-muted">{longing ? "TA 现在没有准备去的地方。" : "TA 现在没有想去的地方。"}</p>
      )}
      {longing ? (
        <>
          <h3 className="ps-plan-shelf__sub">惦记的地方</h3>
          <ul className="ps-plan-cards">
            <li>
              <LongingCard longing={longing} />
            </li>
          </ul>
        </>
      ) : null}
      {after.length ? (
        <>
          <h3 className="ps-plan-shelf__sub">后来怎样{demo ? "（演示）" : ""}</h3>
          <ul className="ps-plan-cards ps-plan-cards--after">
            {after.map((view) => (
              <li key={view.key}>
                <PlanCard view={view} />
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </section>
  );
}
